import { render, staticRenderFns } from "./InsideFeedback.vue?vue&type=template&id=cbb99be6&scoped=true"
import script from "./InsideFeedback.vue?vue&type=script&lang=ts"
export * from "./InsideFeedback.vue?vue&type=script&lang=ts"
import style0 from "./InsideFeedback.vue?vue&type=style&index=0&id=cbb99be6&prod&lang=scss&scoped=true"
import style1 from "./InsideFeedback.vue?vue&type=style&index=1&id=cbb99be6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb99be6",
  null
  
)

export default component.exports